// src/components/Banner.tsx
import React from 'react';
import { Box } from '@mui/material';

interface BannerProps {
  logoSrc?: string;
}

const Banner: React.FC<BannerProps> = ({
  logoSrc = '/full_logo_transparent_background.png', // whichever single logo
}) => {
  return (
    <Box
      component="header"
      sx={{
        width: '100%',
        // Transparent background
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',
        py: 2,
        px: 2,
        pb: 0,
      }}
    >
      <img
        src={logoSrc}
        alt="Impartial AI Logo"
        style={{ height: '80px', width: 'auto' }}
      />
    </Box>
  );
};

export default Banner;
